import {
    RouterComponent as SourceRouterComponent,
    CartPage,
    Checkout,
    CmsPage,
    HomePage,
    MyAccount,
    PasswordChangePage,
    // SearchPage,
    SendConfirmationPage,
    ConfirmAccountPage,
    // MenuPage,
    WishlistShared,
    ContactPage,
    // ProductComparePage,
    CreateAccountPage,
    LoginAccountPage,
    ForgotPasswordPage,
    // StyleGuidePage,
    OrderPrintPage,
    // Header,
    // NavigationTabs,
    // Footer,
    // NewVersionPopup,
    // NotificationList,
    OfflineNotice,
    // CookiePopup,
    // DemoNotice,
    SomethingWentWrong,
    // Breadcrumbs,
    withStoreRegex,
} from 'SourceComponent/Router/Router.component';
import React from 'react';
import { Router as ReactRouter } from 'react-router';
import './Router.override.style';
import ErrorHandler from '@scandipwa/scandipwa/src/component/ErrorHandler';
import { RouterItemType, RouterSwitchItemType } from '@scandipwa/scandipwa/src/component/Router/Router.config';
import { Route, Switch } from 'react-router-dom';
import { PrintTypes } from '@scandipwa/scandipwa/src/component/MyAccountOrderPrint/MyAccountOrderPrint.config';
import { MyAccountTabs } from '@scandipwa/scandipwa/src/type/Account.type';
import UrlRewrites from '@scandipwa/scandipwa/src/route/UrlRewrites';
import BlogPage from 'Route/BlogPage';
import BlogPostPage from 'Route/BlogPostPage';
import OrderTrack from 'Route/OrderTrack';
// import Meta from '@scandipwa/scandipwa/src/component/Meta';
import history from '@scandipwa/scandipwa/src/util/History';
import Footer from '@scandipwa/scandipwa/src/component/Footer';
import Header from '@scandipwa/scandipwa/src/component/Header';
import NotificationList from '@scandipwa/scandipwa/src/component/NotificationList';
import DemoNotice from '@scandipwa/scandipwa/src/component/DemoNotice';
// import NavigationTabs from '@scandipwa/scandipwa/src/component/NavigationTabs';
import Breadcrumbs from '@scandipwa/scandipwa/src/component/Breadcrumbs';
import NewVersionPopup from '@scandipwa/scandipwa/src/component/NewVersionPopup';
import CookiePopup from '@scandipwa/scandipwa/src/component/CookiePopup';
import ViewDiamondPage from 'Route/ViewDiamondPage';
import ColoredDiamondCategoryPage from 'Route/ColoredDiamondCategoryPage';
import { createPortal } from 'react-dom';
import CustomJewelryPage from 'Route/CustomJewelryPage';
import { isSignedIn } from '@scandipwa/scandipwa/src/util/Auth/IsSignedIn';

export {
    CartPage,
    Checkout,
    CmsPage,
    HomePage,
    MyAccount,
    PasswordChangePage,
    // SearchPage,
    SendConfirmationPage,
    ConfirmAccountPage,
    // MenuPage,
    WishlistShared,
    ContactPage,
    // ProductComparePage,
    CreateAccountPage,
    LoginAccountPage,
    ForgotPasswordPage,
    // StyleGuidePage,
    OrderPrintPage,
    // Header,
    // NavigationTabs,
    // Footer,
    // NewVersionPopup,
    // NotificationList,
    OfflineNotice,
    // CookiePopup,
    // DemoNotice,
    SomethingWentWrong,
    // Breadcrumbs,
    withStoreRegex,
};

export class RouterComponent extends SourceRouterComponent {
    [RouterItemType.SWITCH_ITEMS_TYPE] = [
        {
            component: <Route path={withStoreRegex('/custom-jewelry')} render={({ match }) => <CustomJewelryPage match={match} currentUrl={this.props.currentUrl} />} />,
            position: 102,
            name: 'Custom Jewelry',
        },
        {
            component: <Route path={withStoreRegex('/coloreddiamond')} render={({ match }) => <ColoredDiamondCategoryPage match={match} />} />,
            position: 101,
            name: 'Colored Diamond',
        },
        {
            component: <Route path={withStoreRegex('/view_diamond')} render={({ match }) => <ViewDiamondPage match={match} />} />,
            position: 99,
            name: 'ViewDiamond',
        },
        {
            component: <Route path={withStoreRegex('/sales/guest/form/')} render={({ match }) => <OrderTrack match={match} />} />,
            position: 98,
            name: 'orderTrack',
        },
        {
            component: <Route path={withStoreRegex('/blogs')} render={({ match }) => <BlogPage match={match} />} />,
            position: 96,
            name: 'blogs',
        },
        {
            component: <Route path={withStoreRegex('/blog/post')} render={({ match }) => <BlogPostPage match={match} />} />,
            position: 97,
            name: 'blogPost',
        },
        {
            component: <Route path={withStoreRegex('/')} exact render={({ match }) => <HomePage match={match} currentUrl={this.props.currentUrl} />} />,
            position: 10,
            name: RouterSwitchItemType.HOME,
        },
        // {
        //     component: <Route path={withStoreRegex('/search/:query/')} render={({ match }) => <SearchPage match={match} />} />,
        //     position: 25,
        //     name: RouterSwitchItemType.SEARCH,
        // },
        {
            component: <Route path={withStoreRegex('/page')} render={({ match }) => <CmsPage match={match} currentUrl={this.props.currentUrl} />} />,
            position: 40,
            name: RouterSwitchItemType.CMS_PAGE,
        },
        {
            component: <Route path={withStoreRegex('/cart')} exact render={() => <CartPage />} />,
            position: 50,
            name: RouterSwitchItemType.CART,
        },
        {
            component: <Route path={withStoreRegex('/checkout/:step?')} render={({ match }) => <Checkout match={match} />} />,
            position: 55,
            name: RouterSwitchItemType.CHECKOUT,
        },
        {
            component: <Route path={withStoreRegex('/customer/account/createPassword/')} render={() => <PasswordChangePage />} />,
            position: 60,
            name: RouterSwitchItemType.CHANGE_PASSWORD,
        },
        {
            component: <Route path={withStoreRegex('/customer/account/create/')} render={() => <CreateAccountPage />} />,
            position: 61,
            name: RouterSwitchItemType.CREATE_ACCOUNT,
        },
        {
            component: <Route path={withStoreRegex('/customer/account/login/')} render={() => <LoginAccountPage />} />,
            position: 62,
            name: RouterSwitchItemType.LOGIN,
        },
        {
            component: <Route path={withStoreRegex('/customer/account/forgotpassword/')} render={() => <ForgotPasswordPage />} />,
            position: 63,
            name: RouterSwitchItemType.ACCOUNT_FORGOT_PASSWORD,
        },
        {
            component: <Route path={withStoreRegex('/customer/account/confirmation')} render={() => <SendConfirmationPage />} />,
            position: 64,
            name: RouterSwitchItemType.CONFIRM_ACCOUNT,
        },
        {
            component: <Route path={withStoreRegex('/customer/account/confirm')} render={() => <ConfirmAccountPage />} />,
            position: 65,
            name: RouterSwitchItemType.CONFIRM_ACCOUNT,
        },
        {
            component: <Route path={withStoreRegex('/sales/order/view/order_id/:orderId?')} render={({ match }) => <MyAccount match={match} selectedTab={MyAccountTabs.MY_ORDERS} />} />,
            position: 70,
            name: RouterSwitchItemType.MY_ACCOUNT_ORDER,
        },
        {
            component: <Route path={withStoreRegex('/sales/order/history')} render={({ match }) => <MyAccount match={match} selectedTab={MyAccountTabs.MY_ORDERS} />} />,
            position: 71,
            name: RouterSwitchItemType.MY_ACCOUNT_ORDERS,
        },
        {
            component: <Route path={withStoreRegex('/downloadable/customer/products')} render={({ match }) => <MyAccount match={match} selectedTab={MyAccountTabs.MY_DOWNLOADABLE} />} />,
            position: 72,
            name: RouterSwitchItemType.MY_ACCOUNT_DOWNLOADABLE,
        },
        {
            component: <Route path={withStoreRegex('/wishlist')} render={({ match }) => <MyAccount match={match} selectedTab={MyAccountTabs.MY_WISHLIST} />} />,
            position: 73,
            name: RouterSwitchItemType.MY_ACCOUNT_WISHLIST,
        },
        {
            component: <Route path={withStoreRegex('/customer/address')} render={({ match }) => <MyAccount match={match} selectedTab={MyAccountTabs.ADDRESS_BOOK} />} />,
            position: 74,
            name: RouterSwitchItemType.MY_ACCOUNT_ADDRESS,
        },
        {
            component: <Route path={withStoreRegex('/newsletter/manage')} render={({ match }) => <MyAccount match={match} selectedTab={MyAccountTabs.NEWSLETTER_SUBSCRIPTION} />} />,
            position: 75,
            name: RouterSwitchItemType.MY_ACCOUNT_NEWSLETTER,
        },
        {
            component: <Route path={withStoreRegex('/customer/account/:tab?')} render={({ match }) => <MyAccount match={match} />} />,
            position: 76,
            name: RouterSwitchItemType.MY_ACCOUNT,
        },
        // {
        //     component: <Route path={withStoreRegex('/menu')} render={() => <MenuPage />} />,
        //     position: 80,
        //     name: RouterSwitchItemType.MENU,
        // },
        {
            component: <Route path={withStoreRegex('/wishlist/shared/:code')} render={({ match }) => <WishlistShared match={match} />} />,
            position: 81,
            name: RouterSwitchItemType.SHARED_WISHLIST,
        },
        {
            component: <Route path={withStoreRegex('/contact')} render={() => <ContactPage />} />,
            position: 82,
            name: RouterSwitchItemType.CONTACT_PAGE,
        },
        // {
        //     component: <Route path={withStoreRegex('/compare')} render={() => <ProductComparePage />} />,
        //     position: 83,
        //     name: RouterSwitchItemType.COMPARE,
        // },
        // {
        //     component: <Route path={withStoreRegex('/styleguide')} render={() => <StyleGuidePage />} />,
        //     position: 84,
        //     name: RouterSwitchItemType.STYLE_GUIDE,
        // },
        {
            component: <Route path={withStoreRegex('/sales/order/print/order_id/:orderId?')} render={({ match }) => <OrderPrintPage match={match} orderPrintRequest={PrintTypes.PRINT_ORDER} />} />,
            position: 90,
            name: PrintTypes.PRINT_ORDER,
        },
        {
            component: <Route path={withStoreRegex('/sales/order/printInvoice/order_id/:orderId?')} render={({ match }) => <OrderPrintPage match={match} orderPrintRequest={PrintTypes.PRINT_ALL_INVOICES} />} />,
            position: 91,
            name: PrintTypes.PRINT_ORDER,
        },
        {
            component: <Route path={withStoreRegex('/sales/order/printShipment/order_id/:orderId?')} render={({ match }) => <OrderPrintPage match={match} orderPrintRequest={PrintTypes.PRINT_ALL_SHIPMENT} />} />,
            position: 92,
            name: PrintTypes.PRINT_ORDER,
        },
        {
            component: <Route path={withStoreRegex('/sales/order/printCreditmemo/order_id/:orderId?')} render={({ match }) => <OrderPrintPage match={match} orderPrintRequest={PrintTypes.PRINT_ALL_REFUNDS} />} />,
            position: 93,
            name: PrintTypes.PRINT_ORDER,
        },
        {
            component: <Route path={withStoreRegex('/sales/order/printInvoice/invoice_id/:invoiceId?')} render={({ match }) => <OrderPrintPage match={match} orderPrintRequest={PrintTypes.PRINT_INVOICE} />} />,
            position: 94,
            name: PrintTypes.PRINT_ORDER,
        },
        {
            component: <Route path={withStoreRegex('/sales/order/printShipment/shipment_id/:shipmentId?')} render={({ match }) => <OrderPrintPage match={match} orderPrintRequest={PrintTypes.PRINT_SHIPMENT} />} />,
            position: 95,
            name: PrintTypes.PRINT_ORDER,
        },
        {
            component: <Route path={withStoreRegex('/sales/order/printCreditmemo/creditmemo_id/:refundId?')} render={({ match }) => <OrderPrintPage match={match} orderPrintRequest={PrintTypes.PRINT_REFUND} />} />,
            position: 95,
            name: PrintTypes.PRINT_ORDER,
        },
        {
            component: <Route render={({ match }) => <UrlRewrites match={match} location={location} />} />,
            position: 1000,
            name: RouterSwitchItemType.URL_REWRITES,
        },
    ];

    renderDefaultRouterContent() {
        const { isOnlyMainItems } = this.props;
        const { setBigOfflineNotice } = this.props;

        if (isOnlyMainItems) {
            return this.renderMainItems();
        }

        return (
            <ErrorHandler setBigOfflineNotice={setBigOfflineNotice}>
                <div className="Router-MainItems">
                    {this.renderMainItems()}
                </div>
                <Footer />
                <CookiePopup />
            </ErrorHandler>
        );
    }

    renderMeta = () => {
        const { customer, totals } = this.props;

        let items = [];

        let cart = {
            hasItems: totals?.items?.length ? true : false,
        }

        if (totals?.items?.length) {
            totals?.items?.forEach(item => {
                items?.push({
                    sku: item?.sku,
                    parent_sku: item?.product?.sku,
                    name: item?.product?.name,
                    product_type: item?.product?.type_id,
                    price: item?.prices?.price?.value,
                    discount_amount: item?.prices?.total_item_discount?.value,
                    quantity: item?.quantity
                });
            });

            cart = {
                ...cart,
                items: items,
                total: totals?.prices?.grand_total?.value,
                itemCount: totals?.items?.length,
                cartQty: totals?.total_quantity,
                hasCoupons: totals?.prices?.coupon_code ? true : false
            }
        }

        if (isSignedIn()) {
            window?.dataLayer?.push({
                event: "mpCustomerSession",
                customer: {
                    isLoggedIn: true,
                    ...customer
                },
                cart: {
                    ...cart
                }
            });
        } else {
            window?.dataLayer?.push({
                event: "mpCustomerSession",
                customer: {
                    isLoggedIn: false
                },
                cart: {
                    ...cart
                }
            });
        }

        return (
            <>
                <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
                <meta name="mobile-web-app-capable" content="yes" />
                <meta name="apple-mobile-web-app-title" content="BLUEHIRA" />
                <meta name="apple-mobile-web-app-status-bar-style" content="default" />
                <meta name="author" content="" />
                <meta property="og:site_name" content="BLUEHIRA" />
                <meta property="og:image" content="https://www.bluehira.com/media/.thumbswysiwyg/IMG_0393.jpg" />
            </>
        )
    }

    renderMetaTag = () => {
        return createPortal(
            this.renderMeta(),
            document.head,
        );
    }

    render() {
        console.log(this.props, "===>router");
        return (
            <>
                {/* <Meta /> */}
                <ReactRouter history={history}>
                    <NotificationList />
                    <DemoNotice />
                    <Header />
                    {/* <NavigationTabs /> */}
                    <Breadcrumbs />
                    <NewVersionPopup />
                    {this.renderRouterContent()}
                    <div id="appointment-popup" className="modal">
                        <div className="modal-content">
                            <span className="appointment_closeIcon close">×</span>
                            <iframe src="https://calendly.com/bluehira?embed_domain=www.bluehira.com&amp;embed_type=PopupText&amp;hide_landing_page_details=1&amp;hide_gdpr_banner=1&amp;primary_color=89c0a" width="100%" height="100%"></iframe>
                        </div>
                    </div>
                </ReactRouter>
                {this.renderMetaTag()}
            </>
        );
    }
}

export default RouterComponent;
